import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Cookie from 'utils/cookies';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import LoaderSpinner from 'components_v2/common/LoaderSpinner/LoaderSpinner';
import { gamesList } from 'routes/games/layouts/utils';
import PopupOverlay from 'components_v2/common/PopupOverlay/PopupOverlay';
import ImageV2 from 'components_v2/common/ImageV2';
import Link from 'components/Link/Link';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { IMAGE_URL } from 'constants';
import { loadGamesListingData } from '../../../redux';
import GameCard from '../GameCard/GameCard';
import MessageWithIcon from '../MessageWithIcon/MessageWithIcon';
import GameOverlay from '../GameOverlay/GameOverlay';
import s from './GameCardListing.scss';

const GameCardListing = props => {
  const {
    isMobile,
    gamesListing,
    gamesConfigData,
    userData,
    cardProps,
    cardsIncluded,
    includeMoreToComeMessage,
    isCogratulationsPage,
    pageTemplate,
    gaSection,
    gaCategory,
  } = props;

  const userDataRef = useRef(userData);
  const isOutsideClick = useRef(false);
  const autoDismissTimeout = useRef(null);

  const [data, setData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showErrorOverlay, setShowErrorOverlay] = useState(false);
  const [gamesListData, setGamesListData] = useState(gamesList);
  const [showNewGamePopup, setNewGamePopup] = useState(false);

  const loaderCallback = isSuccess => {
    setIsLoading(false);
    if (!isSuccess) {
      setShowErrorOverlay(true);
    }
  };

  const getData = () => {
    if (typeof props.loadGamesListingData === 'function') {
      const ssoId = Cookie.get('ssoid') || Cookie.get('ssoId'); // '8t8n677gs25x9cyosnvl8tlwb'; //
      //   console.log('sso:', Cookie.get('ssoid'))
      const grxId = Cookie.get('_grx'); //'92b423b9-a141-361e-a0ea-81f3cedd2926'; //
      //setIsLoading(true);
      props.loadGamesListingData(
        {
          grxId,
          ssoId,
          isWapView: false,
          clientSide: true,
        },
        loaderCallback,
      );
    }
  };

  useEffect(
    () => {
      // console.log(
      //   'hett:',
      //   userData?.isLoggedIn,
      //   userDataRef?.current?.isLoggedIn,
      // );
      if (
        userData &&
        userData.isLoggedIn !== userDataRef?.current?.isLoggedIn
      ) {
        getData();
      } else if (props.forceLoadDataOnInit) {
        getData();
      }
      userDataRef.current = userData;
    },
    [userData],
  );

  const getLocalStorageKeyPrefix = gameTypeVar => {
    switch (gameTypeVar) {
      case 'sudoku':
        return 'tilsudoku';
      case 'location-guesser':
        return 'tillocationguesser';
      case 'loop-a-loop':
        return 'tilloopaloop';
      case 'whos-that':
        return 'tilwhoisthat';
      case 'connect':
        return 'tilconnect';
      default:
        return 'tilstate';
    }
  };

  const handleCloseNewGamePopup = labelVal => {
    setNewGamePopup(false);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'close',
      label: labelVal || '',
    });
    analyticsWrapper('grx', 'track', 'user_click', {
      event: 'user_click',
      type: 'close',
      label: labelVal || '',
    });
    if (autoDismissTimeout.current) {
      clearTimeout(autoDismissTimeout.current);
      autoDismissTimeout.current = null;
      document
        .getElementsByTagName('body')[0]
        .classList.remove('disable-scroll');
    }
  };

  // When the user clicks the close button manually
  const handleUserClosePopup = () => {
    if (!isOutsideClick.current) {
      handleCloseNewGamePopup('cross');
    }
    isOutsideClick.current = false; // Reset the flag after handling
  };

  // When the user clicks outside the popup
  const handleOutsideClickClose = () => {
    isOutsideClick.current = true; // Mark that it was an outside click
    handleCloseNewGamePopup('away_click');
  };

  const checkNewGamePopupStatus = () => {
    if (typeof localStorage !== 'undefined') {
      let toigames = localStorage.getItem('toigames');
      toigames = toigames ? JSON.parse(toigames) : {};

      if (!toigames.popupshownfor) {
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'whos_that_popup',
        });
        setTimeout(() => {
          setNewGamePopup(true);

          toigames.popupshownfor = 'whos-that';
          localStorage.setItem('toigames', JSON.stringify(toigames));

          autoDismissTimeout.current = setTimeout(() => {
            handleCloseNewGamePopup('auto_dismiss');
          }, 15000);
        }, 1500);
      }
    }
  };

  useEffect(
    () => {
      if (
        isCogratulationsPage &&
        !(data && Array.isArray(data)) &&
        gamesListing &&
        gamesListing.items &&
        Array.isArray(gamesListing.items)
      ) {
        let { items } = gamesListing;
        items = items.map(item => {
          let sortOrder;
          const gameStatuses =
            item &&
            item.gameCategoryData &&
            Array.isArray(item.gameCategoryData.gameStatus)
              ? item.gameCategoryData.gameStatus
              : [];
          const allFinished =
            gameStatuses.length > 0 &&
            gameStatuses.every(status => status.hasPlayed);
          const anyPaused = gameStatuses.some(status => status.hasPaused);
          const anyPausedInLocalStorage = gameStatuses.some(status =>
            localStorage.getItem(
              `${getLocalStorageKeyPrefix(item?.gameType)}:${status.gameId}`,
            ),
          );

          if (allFinished) {
            sortOrder = 3;
          } else if (anyPaused || anyPausedInLocalStorage) {
            sortOrder = 2;
          } else {
            sortOrder = 1;
          }
          return { ...item, sortOrder };
        });
        items.sort((a, b) => a.sortOrder - b.sortOrder);
        setData(items);
        // console.log('gamesListing:', items);
      }
      if (
        !isCogratulationsPage &&
        gamesListing &&
        gamesListing.items &&
        Array.isArray(gamesListing.items) &&
        gamesListing.items.length > 0
      ) {
        setGamesListData(gamesListing);
        //checkNewGamePopupStatus();
      }
    },
    [gamesListing],
  );

  const gameOverlayCallback = () => {
    setShowErrorOverlay(false);
  };

  if (isLoading) {
    return (
      <div
        className={`${s.loaderouter} ${
          props.loaderClass ? s[props.loaderClass] : ''
        }`}
      >
        <LoaderSpinner overwriteLoader={s.spinner} />
      </div>
    );
  }

  if (showErrorOverlay) {
    return (
      <GameOverlay
        popUpType="errorPopUp"
        gameOverlayCallback={gameOverlayCallback}
      />
    );
  }
  return (
    <>
      {!isCogratulationsPage &&
        gamesListData &&
        gamesListData.items &&
        Array.isArray(gamesListData.items) &&
        gamesListData.items.map(sectionItem => {
          let commonGameCardProps = {
            data: sectionItem.gameCategoryData,
            userData,
            ...cardProps,
          };
          if (
            sectionItem &&
            sectionItem.tn === 'gameCategory' &&
            sectionItem.gameCategoryData &&
            sectionItem.gameCategoryData.gameType &&
            cardsIncluded.includes(sectionItem.gameCategoryData.gameType)
          ) {
            const gameType = sectionItem.gameCategoryData.gameType.replace(
              /_/g,
              '-',
            );
            if (gamesConfigData && gamesConfigData) {
              const gameCategoryConfigData =
                gamesConfigData?.gameCategories &&
                gamesConfigData.gameCategories[
                  sectionItem.gameCategoryData.gameType
                ];
              if (gameCategoryConfigData) {
                commonGameCardProps = {
                  ...commonGameCardProps,
                  gameCategoryConfigData,
                };
              }
            }
            return (
              <>
                <GameCard
                  gameType={gameType}
                  {...commonGameCardProps}
                  subSection={gaSection || gameType}
                  pageTemplate={pageTemplate || 'listing'}
                  ga4Category={gaCategory}
                  calledFrom="game_listing"
                />
              </>
            );
          }
          return null;
        })}
      {isCogratulationsPage &&
        data &&
        Array.isArray(data) &&
        data.map(sectionItem => {
          let commonGameCardProps = {
            data: sectionItem.gameCategoryData,
            userData,
            ...cardProps,
          };
          if (
            sectionItem &&
            sectionItem.tn === 'gameCategory' &&
            sectionItem.gameCategoryData &&
            sectionItem.gameCategoryData.gameType &&
            cardsIncluded.includes(sectionItem.gameCategoryData.gameType)
          ) {
            const gameType = sectionItem.gameCategoryData.gameType.replace(
              /_/g,
              '-',
            );
            if (gamesConfigData && gamesConfigData) {
              const gameCategoryConfigData =
                gamesConfigData?.gameCategories &&
                gamesConfigData.gameCategories[
                  sectionItem.gameCategoryData.gameType
                ];
              if (gameCategoryConfigData) {
                commonGameCardProps = {
                  ...commonGameCardProps,
                  gameCategoryConfigData,
                };
              }
            }
            return (
              <>
                <GameCard
                  gameType={gameType}
                  {...commonGameCardProps}
                  calledFrom="game_listing"
                />
              </>
            );
          }
          return null;
        })}
      {!isCogratulationsPage &&
        gamesList &&
        gamesList.items &&
        Array.isArray(gamesList.items) &&
        gamesList.items.length > 0 &&
        includeMoreToComeMessage && <MessageWithIcon text="More to come..." />}
      {showNewGamePopup && (
        <PopupOverlay
          position="center"
          closeCallback={handleUserClosePopup}
          show={showNewGamePopup}
          blackOverlayEnabled
          outSideClickClose
          noGap
          roundCross
          noBoxShadow
          outSideClickHandler={handleOutsideClickClose}
        >
          <Link
            className={s.popupImage}
            to="/games/whos-that/today?src=whos-that_popup&med=games_listing&camp=games"
            onClick={() => {
              analyticsWrapper('ga4', {
                event: 'user_click',
                type: 'popup_click',
                category: 'whos_that',
              });
              analyticsWrapper('grx', 'track', 'user_click', {
                event: 'user_click',
                type: 'popup_click',
                category: 'whos_that',
              });
              handleCloseNewGamePopup('link_click');
            }}
          >
            <ImageV2
              msid={isMobile ? 119525671 : 119525666}
              resizemode={4}
              // imgsize={banner.imagesize}
              width={isMobile ? 670 : 1200}
              alt="Whos That"
              title="Whos That"
              placeHolderSrc={`${IMAGE_URL}83033472.cms`}
              lazyload
            />
          </Link>
        </PopupOverlay>
      )}
    </>
  );
};

GameCardListing.propTypes = {
  isMobile: PropTypes.bool,
  gamesListing: PropTypes.shape({}),
  gamesMetaWidget: PropTypes.shape({}),
  cardProps: PropTypes.shape({}),
  loadGamesListingData: PropTypes.func,
  cardsIncluded: PropTypes.arrayOf(PropTypes.string),
  includeMoreToComeMessage: PropTypes.bool,
  forceLoadDataOnInit: PropTypes.bool,
  isCogratulationsPage: PropTypes.bool,
};

GameCardListing.defaultProps = {
  isMobile: false,
  gamesListing: undefined,
  gamesMetaWidget: undefined,
  loadGamesListingData: () => {},
  cardProps: {},
  cardsIncluded: [
    'crossword',
    'mini_crossword',
    'sudoku',
    'location_guesser',
    'loop_a_loop',
    'whos_that',
    'connect',
  ],
  includeMoreToComeMessage: false,
  forceLoadDataOnInit: false,
  isCogratulationsPage: false,
};

const mapStateToProps = state => ({
  gamesListing: _get(state, 'toigames.gameslisting', {}),
  gamesConfigData: _get(state, 'toigames.gamesconfig', {}),
  userData: state.login.userData,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  loadGamesListingData: (params, loaderCallback) => {
    dispatch(loadGamesListingData(params, loaderCallback));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GameCardListing);
